import React from "react";

const Introduction = () => {
  return (
    <React.Fragment>
      <h1>An Introduction to Publishing with Cureus Journal of Engineering (CJoE)</h1>

      <h2>
        <strong>Open Access Statement</strong>
      </h2>
      <p>
        Cureus Journals make all published articles freely available to all readers worldwide
        immediately upon publication, ensuring maximum dissemination of articles. Readers can read
        and download content without registering for an account. Cureus Journals utilize a
        Continuous Article Publication (CAP) model, reducing publication time to a minimum and
        ensuring timely communication with the community.
      </p>

      <h2>
        <strong>CAP Model</strong>
      </h2>
      <p>
        CAP is a model where journals publish articles as soon as they are accepted, rather than
        waiting for all articles to be ready. This approach allows for faster dissemination of
        research, as articles are quickly made available to readers. Cureus Journals publish
        articles with volume numbers as soon as they get editorial approval following a rigorous
        peer review.
      </p>

      <h2>
        <strong>Acceptance Policy and Editing Fees</strong>
      </h2>
      <p>
        CJoE is committed to providing easy, timely, and affordable article publication. We expect
        all submissions to adhere to our rigorous formatting and language requirements. Placing this
        responsibility on our author via a self-explanatory submission process gives authors a
        chance to publish with zero <a href="/cureus_editing_services">Preferred Editing Fees</a>.
      </p>
      <p>
        Publication costs for CJoE are covered by Springer Nature until June 30, 2025.
        Authors whose articles are accepted for publication up to and including that date will not pay any preferred editing fees.
        For all articles submitted between May 1, 2025, and December 31, 2025, the maximum preferred editing fee shall be USD 99.
      </p>
      <p>
        Articles that exceed our author or reference limits or contain formatting and language
        errors identified during preliminary review by our in-house editors will require a dynamic
        editing fee. Please note that the editing fee needs to be paid before peer review
        initiation. CJoE does not ask for article processing charges (APCs).
      </p>
      <p>
        After preliminary screening, the manuscript enters peer review. Following a rigorous peer
        review process, external associate editors decide on the final publication of the submitted
        manuscript.
      </p>

      <h2>
        <strong>Refund policy: Eligibility for refund</strong>
      </h2>
      <p>
        Manuscripts rejected after a rigorous peer review or associate editor’s review shall receive
        a full refund of the preferred editing fees. No refund will be provided for articles
        rejected due to fraud, plagiarism, or if the article is voluntarily withdrawn by the author.
      </p>

      <h2>
        <strong>Credible Peer Review Required</strong>
      </h2>
      <p>
        CJoE publishes credible research in the field of{" "}
        <a href="/specialties" target="_blank" rel="noopener">
          Engineering
        </a>
        . The credibility of submitted manuscripts is determined by peer reviewers via a
        single-blind peer review process that provides substantial critical feedback confirming the
        absence of fatal scientific and methodological flaws or other significant concerns that
        could compromise the validity, reliability, and/or ethical integrity of the documented
        research.
      </p>
      <p>
        Authors are expected to suggest unbiased and expert reviewers who can provide critical
        feedback. All reviewers suggested by authors will be evaluated by an in-house associate
        editor before the peer review process begins. Positive reviews lacking substantial
        constructive feedback will be closely scrutinized by our editors and may be rejected.
        Inviting credible reviewers is of paramount importance. Please note that Ph.D. scholars or
        students should not be invited to peer review.
      </p>
      <p>
        While authors are required to suggest at least five peer reviewers, CJoE also invites
        independent peer reviewers. To complete the peer review process, a minimum of two completed
        reviews from CJoE-invited reviewers is required. For more information on the CJoE peer
        review process, please refer to our{" "}
        <a href="/reviewer_guide#!/overview/why-review-with-cureus" target="_blank" rel="noopener">
          Reviewer Guide
        </a>
        .
      </p>
    </React.Fragment>
  );
};

export default Introduction;
